import { GridFooterCellProps } from '@progress/kendo-react-grid';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';
import { round } from 'src/utils';
import { getBgColor } from 'src/utils/icons';

const PercentageFooterCell = (props: GridFooterCellProps) => {
  const { totalPercentage, errorMessage, footerInfoMessage } = useViewBudgetPeriod();

  return (
    <td className={getBgColor(errorMessage.totalPercentage, [], footerInfoMessage)}>
      <p className="text-left">{round(totalPercentage)}%</p>
    </td>
  );
};

export default PercentageFooterCell;
